import { forwardRef, useEffect, useState } from "react"
import { StyledPortionInput } from "../PortionInput/styled"

export interface IUnitInputProps {
  value: string
  onChange: (value: string) => void
  isError?: boolean
  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
}

type Ref = HTMLInputElement

const UnitInput = forwardRef<Ref, IUnitInputProps>((props, ref) => {
  const { value, disabled = false, onChange, setIsPortionValid } = props

  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value)
    }
  }, [value])

  const onUnitChange = (value: string) => {
    setLocalValue(value)
    onChange(value)

    if (!value) {
      setIsPortionValid?.(false)
    } else {
      setIsPortionValid?.(true)
    }
  }

  // const onBlur = () => {
  //   if (localValue === "" || localValue === null) {
  //     setLocalValue("unit")
  //     onChange("unit")
  //     setIsPortionValid?.(true)
  //   }
  // }

  return (
    <StyledPortionInput
      // onBlur={onBlur}
      ref={ref}
      value={localValue}
      onChange={(e) => {
        if (!disabled) {
          onUnitChange(e.target.value)
        }
      }}
    />
  )
})

export default UnitInput
